import Controller, { OnClick, OnMount, OnNavigate } from '@philips-internal/oswald-ui-core/lib/client';
import { MountEvent, NavigateEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import { FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

import { TabControlAPI } from '@philips-internal/oswald-ui-components';
import { Inject } from '@odinjs/odin';
import { TabWithContentAPI } from '@philips-internal/oswald-ui-components/lib/components/tab';
import { MyChartAllergiesAliases } from '../../codegen';
import { MyChartTabStructure } from '../../constants/my-chart-tab-structure';
import { MyChartControlItems } from '../../constants/my-chart-tab-control-items';

@Controller({ fragment: FragmentNames.MY_CHART_ALLERGIES })
export default class MyChartAllergiesController extends BaseController {

  @Inject(MyChartAllergiesAliases.TAB_HOSPITAL)
    tabHospital!: TabWithContentAPI;

  @OnClick({ target: MyChartAllergiesAliases.ACTION_NEW })
  onClickNew(): void {
    applicationContext.redirect(APPLICATION_ROUTES.MY_CHART_ALLERGIE_NEW, {});
  }

  @OnMount({ target: [ MyChartAllergiesAliases.TAB_HOSPITAL ] })
  handleHospitalTabLoading(): void {
    const tabVisibility = this.context.get('tabVisibility') as MyChartTabStructure;
    if (tabVisibility.tabName === MyChartControlItems.ALLERGIES_HOSPITAL_VISIBILITY) {
      this.tabHospital.setVisible(tabVisibility.visibility);
    }
  }

  @OnMount(MyChartAllergiesAliases.TAB_CONTROL_ALLERGIES)
  onMountTabWithContent(event: MountEvent): void {
    const tabControll = event.target as TabControlAPI;
    this.context.set({ 'currentTab': tabControll.getDefaultTab() });
  }

  @OnNavigate(MyChartAllergiesAliases.TAB_CONTROL_ALLERGIES)
  onNavigateTabControl(event: NavigateEvent<string>): void {
    this.context.set({ 'currentTab': event.to });
  }

}